<template>
  <ValidationObserver v-slot="{ errors, failed }" slim>
    <div class="field">
      <label class="label" :class="{ 'has-text-danger': failed }">
        Options
      </label>
      <ValidationProvider ref="validator" rules="required|min:2">
        <input v-model="data" type="hidden" />
      </ValidationProvider>
      <draggable
        v-model="data"
        tag="div"
        :animation="200"
        ghost-class="ghost"
        handle=".handle-option"
      >
        <!-- @start="drag = true"
          @end="drag = false" -->
        <!-- class="question-list" -->
        <div
          v-for="(choice, idx) in data"
          :key="`choice-${idx}`"
          class="control has-icons-right is-choice has-icons-left"
        >
          <input v-model="data[idx].choiceText" class="input" type="text" />
          <span class="icon is-left handle-option is-interactive">
            <font-awesome-icon icon="grip-vertical"></font-awesome-icon>
          </span>
          <span class="icon is-right is-interactive" @click="removeValue(idx)">
            <i class="icon-close"></i>
          </span>
        </div>
        <template v-slot:footer>
          <div class="control has-icons-right is-choice">
            <input
              v-model="newValue"
              class="input"
              type="text"
              placeholder="Add option"
              :class="{ 'is-danger': failed }"
              @keydown.enter="addNewValue"
              @blur="runValidator"
            />
            <span class="icon is-right is-interactive" @click="addNewValue">
              <font-awesome-icon icon="plus"></font-awesome-icon>
            </span>
          </div>
        </template>
      </draggable>

      <span class="help" :class="{ 'is-danger': failed }">
        {{ Object.values(errors).flatMap(x => x)[0] }}
      </span>
    </div>
  </ValidationObserver>
</template>

<script>
import draggable from 'vuedraggable';
import isEqual from 'lodash/isEqual';
import _ from 'lodash';
// "choiceText": "string",
//           "choiceValue": 0,
//           "sortOrder": 0
export default {
  name: 'ChoicesList',
  components: {
    draggable
  },
  props: {
    value: {}
  },
  data() {
    return {
      data: this.value || [],
      newValue: ''
    };
  },
  watch: {
    value: {
      deep: true,
      handler() {
        if (!isEqual(this.value, this.data)) {
          console.log('change value');

          this.data = _.sortBy(this.value, 'sortOrder');
        }
      }
    },
    data: {
      deep: true,
      handler() {
        if (!isEqual(this.value, this.data)) {
          this.$emit('input', this.data);
        }
        this.$refs.validator.validate();
      }
    }
  },
  methods: {
    addNewValue() {
      if (this.newValue.trim() != '') {
        let counter = _.chain(this.data)
          .orderBy('choiceValue')
          .last()
          .get('choiceValue', 0)
          .value();

        this.data.push({
          choiceText: this.newValue,
          choiceValue: ++counter
        });
        this.newValue = '';
      }
    },
    removeValue(idx) {
      this.data.splice(idx, 1);
      // const idx = this.tags.indexOf(tag);
      // if (idx > -1) {
      //   this.tags.splice(idx, 1);
      // }
    },
    runValidator() {
      this.$refs.validator.validate();
    }
  }
};
</script>

<style lang="scss">
.is-choice {
  max-width: 380px;
  &:not(:last-child) {
    margin-bottom: $block-spacing;
  }
}
</style>
